import Dialog from './plugins/dialog';
import Breadcrumbs from './plugins/breadcrumbs';

export default
{
    Dialog,
    Breadcrumbs
}